<template>
  <div class="content">
    <base-header :choose-index="6"></base-header>
    <div class="middle_content">
      <img class="middle_content-post" ref="post" src="@@/assets/img/westa/shopping/在线购买配图.png" />

      <div class="qudao" style="padding: 20px;">
        <h3>长帝网络销售体系</h3>
      </div>
      <div style="width: 1240px;margin-left: auto;margin-right: auto;display: flex;justify-content: space-between;">
        <div style="flex:1">
          <!--分割线-->
          <a href="http://t.cn/RpxiYFS?changdi.tmall.com" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <div style="flex:1;padding: 10px;">
                <p>2010年4月天猫长帝旗舰店开张以来屡创佳绩，2013年双11，当天成交1446万元，创造单日突破千万的记录，2014年，3.5版电烤箱新品首发，1分钟疯抢4570台，再创销售神话！</p>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/Sale01.png" width="300" height="132" alt />
              </div>
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
            </div>
          </a>

          <!--分割线-->
          <a href="https://mobile.yangkeduo.com/mall_page.html?refer_share_uid=4151257153&refer_share_id=6zxMyVXAjNPitgQLWItB7Ar1IVpyi0FN&msn=wfuwavcz4xs7zhauxlymy7hvie_axbuy&refer_share_channel=message&_wv=41729&share_uid=4151257153&mall_id=725957385&_wvx=10" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
              <div style="flex:1;padding: 10px;">
                <p>2018年长帝成功入驻拼多多！</p>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/Sale06.png" width="300" height="132" alt />
              </div>
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
            </div>
          </a>

          <!--分割线-->
          <a href="https://list.vip.com/brand.html?sn=10015111" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
              <div style="flex:1;padding: 10px;">
                <p>2019年长帝成功入驻唯品会！</p>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/Sale08.png" width="300" height="132" alt />
              </div>
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
            </div>
          </a>

          <!--分割线-->
          <a href="https://www.xiaohongshu.com/vendor/5b863914bb06cd3f389b7a4b?xhsshare=CopyLink&appuid=5b9b4726d400b0000173891e&apptime=1576486771" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
              <div style="flex:1;padding: 10px;">
                <p>2019年长帝成功入驻小红书！</p>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/Sale07.png" width="300" height="132" alt />
              </div>
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
            </div>
          </a>

          <!--分割线-->
          <a href="https://shop195929.m.youzan.com/wscshop/showcase/homepage?kdt_id=3761" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
              <div style="flex:1;padding: 10px;">
                <p>长帝成功入驻有赞！</p>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/youzan.png" width="300" height="132" alt />
              </div>
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
            </div>
          </a>
        </div>
        <div style="height: 900px;width: 2px;background: #181f99;"></div>
        <div style="flex:1">
          <!--分割线-->
          <a href="http://t.cn/EbNkkMi?mall.jd.com/index-1000001342.html" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 60px;">
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/Sale02.png" width="300" height="132" alt />
              </div>
              <div style="flex:1;padding: 10px;">
                <p>2011年长帝入驻京东，一直稳居京东电烤箱销量第一，短短两年，创下京东销售额单月突破1000万，占比稳居56%以上，单日销售额突破251万！</p>
              </div>
            </div>
          </a>

          <!--分割线-->
          <a href="https://shop.suning.com/30000433/index.html" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/Sale03.png" width="300" height="132" alt />
              </div>
              <div style="flex:1;padding: 10px;">
                <p>2012年长帝入驻苏宁易购，仅运营一年，2013年销售突破1000万！</p>
              </div>
            </div>
          </a>

          <!--分割线-->
          <a href="https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=3512386345375023179&origin_type=604" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/douyin.png" width="300" height="132" alt />
              </div>
              <div style="flex:1;padding: 10px;">
                <p>长帝成功入驻抖音！</p>
              </div>
            </div>
          </a>

          <!--分割线-->
          <a href="https://app.kwaixiaodian.com/merchant/shop/detail?id=15339561134635" target="_blank">
            <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
              <div style="display: flex;align-items: center;">
                <div style="width: 70px;height: 2px;background: #181f99;"></div>
                <div></div>
              </div>
              <div style="flex-shrink: 0;">
                <img style="border-radius: 12px;border: 2px solid #181f99;" src="@@/assets/img/westa/shopping/kuaishou.png" width="300" height="132" alt />
              </div>
              <div style="flex:1;padding: 10px;">
                <p>长帝成功入驻快手！</p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="qudao index_padding">
        <div class="mini_center">
          <div class="tixi">
            <div class="qidai">未来敬请期待</div>
          </div>

          <div class="shop index_padding">
            <h3>正品授权店铺</h3>
            <ul class="shop_list clear">
              <li class="fl clear">
                <a href="http://t.cn/RpxiYFS?changdi.tmall.com" target="_blank">
                  <h4 class="fl">长帝天猫旗舰店</h4>
                  <div class="fr clear">
                    <span class="fr">立即进入</span>
                    <p class="fr">天猫旗舰店</p>
                  </div>
                </a>
              </li>
              <li class="fr clear">
                <a href="https://changdicdpy.tmall.com/" target="_blank">
                  <h4 class="fl">长帝璞瑜专卖店</h4>
                  <div class="fr clear">
                    <span class="fr">立即进入</span>
                    <p class="fr">天猫专卖店</p>
                  </div>
                </a>
              </li>
              <li class="fl clear">
                <a href="https://detail.tmall.com/item.htm?ali_refid=a3_430582_1006:1550690069:N:44M3z0Dj5ThobMKpV7SIEA==:ff00c333d6f825cbca56c452dce901ba&ali_trackid=1_ff00c333d6f825cbca56c452dce901ba&id=717550156410&spm=a21n57.1.0.0" target="_blank">
                  <h4 class="fl">长帝9531专卖店</h4>
                  <div class="fr clear">
                    <span class="fr">立即进入</span>
                    <p class="fr">天猫专卖店</p>
                  </div>
                </a>
              </li>
              <li class="fr clear">
                <a href="https://detail.tmall.com/item.htm?abbucket=0&id=643266071859&ns=1&spm=a21n57.1.0.0.4e99523cucac3k" target="_blank">
                  <h4 class="fl">易明电器专营店</h4>
                  <div class="fr clear">
                    <span class="fr">立即进入</span>
                    <p class="fr">天猫专营店</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <base-footer></base-footer>
  </div>
</template>

<script>
  import BaseHeader from "@@/components/westa/base-header";
  import BaseFooter from "@@/components/westa/base-footer";
  export default {
    data() {
      return {};
    },
    components: {
      BaseHeader,
      BaseFooter,
    },
    mounted() {},
  };
</script>

<style lang="less" scoped>
  .middle_content {
    padding-top: 60px;
    min-width: 1200px;
    &-post {
      width: 100%;
      height: auto;
    }
  }
  .inside_img {
    height: 360px;
  }
  * {
    padding: 0;
    margin: 0;
    outline: 0;
    text-decoration: none;
    list-style: none;
  }
  html,
  body {
    font-size: 14px;
    // font-family: "Microsoft YaHei";
  }
  input {
    border: none;
  }
  img {
    border: none;
  }
  audio,
  canvas,
  video {
    display: inline-block;
    *display: inline;
    *zoom: 1;
  }
  a {
    color: #000;
    -webkit-tap-highlight-color: transparent;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .clear:after {
    content: "";
    display: table;
    clear: both;
  }
  .main_center {
    width: 1200px;
    margin: 0 auto;
  }
  .index_padding {
    padding: 20px 0;
  }
  .index_bg {
    background: #f5f5f5;
  }
  .mini_center {
    width: 1240px;
    margin: 0 auto;
  }
  .qudao h3 {
    font-weight: normal;
    font-size: 24px;
    color: #333;
    // font-family: "宋体";
    text-align: center;
  }
  .tixi_content {
    position: relative;
    height: 1030px;
    margin-top: 60px;
  }
  .tixi_bg {
    width: 140px;
    top: 40px;
    left: 50%;
    margin-left: -70px;
    position: absolute;
  }
  .tixi_bg img {
    width: 100%;
    vertical-align: bottom;
  }
  .tixi_list {
    position: relative;
  }
  .tixi_list li {
    width: 550px;
    height: 132px;
    position: absolute;
    left: 0;
  }
  .tixi_list li.tixi_right {
    left: 690px;
  }
  .tixi_list li.suming {
    margin-top: 0;
  }
  .tixi_des {
    width: 240px;
    height: 110px;
  }
  .tixi_list li img {
    vertical-align: bottom;
    max-width: 100%;
  }
  .tixi_list li table {
    width: 100%;
    height: 100%;
  }
  .tixi_list li table td {
    vertical-align: middle;
  }
  .tixi_list li p {
    font-size: 12px;
    color: #333;
    line-height: 20px;
  }
  .qidai {
    text-align: center;
    font-size: 16px;
    letter-spacing: 20px;
    text-indent: 20px;
    color: #999;
  }
  .tixi_list li a {
    display: block;
    width: 100%;
    height: 100%;
  }
  .tixi_list li.li1 {
    top: 0;
  }
  .tixi_list li.li2 {
    top: 100px;
  }
  .tixi_list li.li3 {
    top: 200px;
  }
  .tixi_list li.li4 {
    top: 300px;
  }
  .tixi_list li.li5 {
    top: 400px;
  }
  .tixi_list li.li6 {
    top: 500px;
  }
  .tixi_list li.li7 {
    top: 600px;
  }
  .tixi_list li.li8 {
    top: 700px;
  }
  .tixi_list li.li9 {
    top: 800px;
  }
  .tixi_list li a .tixi_img {
    // border: 1px solid transparent;
    text-align: center;
    border: 2px solid #181f99;
    border-radius: 12px;
  }
  .tixi_list li a:hover .tixi_img {
    // border-color: #181f99;
    box-shadow: 0 2px 12px 0 rgba(24, 31, 153, 0.2);
  }
  .tixi_list li a:hover p {
    color: #181f99;
  }
  .shop {
    border-top: 1px solid #ddd;
    margin-top: 6%;
  }
  .shop h3 {
    padding: 2% 0;
  }
  .shop_list li {
    width: 48%;
    height: 50px;
    line-height: 50px;
    background: #f5f5f5;
    margin-top: 20px;
  }
  .shop_list li h4 {
    font-size: 16px;
    color: #333;
    font-weight: normal;
    margin-left: 18px;
  }
  .shop_list li p {
    margin-right: 18px;
    color: #999;
  }
  .shop_list li span {
    width: 0;
    line-height: 50px;
    background: #181f99;
    text-align: center;
    color: #fff;
    font-size: 16px;
    overflow: hidden;
    height: 50px;
  }
  .shop_list li span img {
    vertical-align: middle;
    margin-top: -4px;
    margin-right: 4px;
  }
  .shop_list li a {
    display: block;
    width: 100%;
    height: 100%;
  }
  .shop_list li:hover span {
    width: 140px;
  }
  /***** 过渡 *****/
  .shop_list li span {
    -webkit-transition: all 0.3s linear;
    -moz-transition: all 0.3s linear;
    -ms-transition: all 0.3s linear;
    -o-transition: all 0.3s linear;
    transition: all 0.3s linear;
  }
</style>
